module.exports = __webpack_public_path__ + "img/pulpo-brasa.ddf9b1c7.jpg";